import type React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useProgramPageRedirect } from '@pages/programs/program-page/helpres.ts';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import * as listStyles from '@features/clients/articles_and_programs_list/common/list_styles.module.scss';
import { ListCard } from '@features/clients/articles_and_programs_list/common/ui/index.ts';
import { Blank } from '@src/library/components/common/index.ts';
import { useLoadPrograms } from './model.ts';

type Props = {
  id: number;
  code: string;
};

export const RentedProgramList: React.FC<Props> = ({ id, code }) => {
  const location = useLocation();

  const { loading, programs, hasNextPage, loadMore } = useLoadPrograms(id, code);

  const { doSavePageUrl } = useProgramPageRedirect();

  return (
    <InfinityList
      hasMore={hasNextPage}
      loadMore={loadMore}
      loading={loading}
      className={listStyles.list}
    >
      {!loading && !programs.length && <Blank text="Здесь пока нет программ" />}

      {programs.map((program) => {
        const { pk, author, promo_image, title, created } = program;
        return (
          <Link
            to={`/programs/library/program/${pk}`}
            key={pk}
            state={location}
            onClick={doSavePageUrl}
          >
            <ListCard author={author} title={title} img={promo_image} created={created} />
          </Link>
        );
      })}
    </InfinityList>
  );
};
